export { AccordionPanel } from './accordion-panel';
export type { AccordionPanelProps } from './types';
